var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelfieldColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 493.4 72",
    style: {
      enableBackground: "new 0 0 493.4 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000005247418565696971020000007738851970132857498_);fill:#0071CE;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 493.4,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062187645371864343170000013449877253849921722_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M491.8,10.9 c0,2.5-1.8,4.1-3.8,4.1v0c-2.1,0-3.9-1.7-3.9-4.1c0-2.5,1.7-4.1,3.9-4.1C490.1,6.8,491.8,8.4,491.8,10.9 M487.1,11.3h0.6l1.3,2.4 h1.5l-1.5-2.5c0.8-0.1,1.4-0.4,1.4-1.5c0-1.3-0.9-1.8-2.4-1.8h-2.2v5.8h1.2V11.3z M487.1,10.4V9h0.9c0.5,0,1.1,0,1.1,0.6 c0,0.6-0.3,0.7-0.9,0.7H487.1z M493.4,10.9c0-3.4-2.5-5.4-5.4-5.4c-2.9,0-5.4,2-5.4,5.4c0,3.4,2.5,5.4,5.4,5.4 C490.9,16.3,493.4,14.3,493.4,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M38.7,27.9h8.8 c5.4,0,7.2,1.8,7.2,6c0,1.5-0.4,3.9-1.8,9.2c-1.3,5.5-5,10.2-11.2,10.2H31.7L38.7,27.9z M0,70.1h51.9c9,0,20.3-4.5,25.1-17.5 c4.4-11.7,6.7-19.7,6.7-27.6c0-14.6-9.1-17.9-18.7-17.9H17.2L0,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M116.7,37.6 c2.6-7.4,6.1-9.2,12.3-9.2c2.3,0,6.7,1,6.7,4.9c0,1.3-0.3,2.7-0.5,4.2H116.7z M153.7,48.8c1.6-3.5,4.4-12.4,4.4-15.5 c0-14.4-9.1-18.6-32.8-18.6c-11.5,0-21,0.4-28.9,9.7c-4.9,5.9-10.2,19-10.2,30.7c0,15.6,15.1,16.8,27.2,16.8 c9.9,0,19.9-1.4,29.4-3.9l6.9-14c-7.9,1.7-16,3.5-24.3,3.5c-5.7,0-12.8-0.2-12.8-5.9c0-0.8,0.1-1.7,0.4-2.8H153.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    points: "175.2,4.1  201,4.1 183.3,70.1 157.5,70.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M203.2,47.4h-7 l4.9-17.7h7.2l3.2-13.5c2.8-11,11.6-13.2,25.3-13.2c6.8,0,13.7,0.5,20.3,1.3l-4.2,16c-2.9-0.3-5.9-0.5-8.8-0.5c-4,0-7,0.7-8.6,4.7 l-1.4,5.2h16.2l-5.1,17.7h-15.9L223,70.1h-25.8L203.2,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M261,15.9 c3.1,0.4,8.1,0.8,13.2,0.8h0.2c5.6,0,9.4-0.4,12.5-0.8l-14.5,54.2h-25.8L261,15.9z M286,0c3.1,0,4.7,0.6,4.7,1.9 c0,0.7-1.1,4.9-1.9,7.5c-0.8,2.6-4.9,2.7-12.5,2.7h-4.1c-6.4,0-9.6-0.1-9.6-2.1c0-1.3,0.4-3.7,1.1-5.7c1.2-3.5,1.7-4.2,10.7-4.2 H286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M317.1,37.6 c2.7-7.4,6.1-9.2,12.3-9.2c2.3,0,6.7,1,6.7,4.9c0,1.3-0.3,2.7-0.5,4.2H317.1z M354.1,48.8c1.6-3.5,4.4-12.4,4.4-15.5 c0-14.4-9.1-18.6-32.8-18.6c-11.5,0-21,0.4-28.9,9.7c-4.9,5.9-10.2,19-10.2,30.7c0,15.6,15.1,16.8,27.2,16.8 c9.9,0,19.9-1.4,29.4-3.9l6.9-14c-7.9,1.7-16,3.5-24.3,3.5c-5.7,0-12.8-0.2-12.8-5.9c0-0.8,0.1-1.7,0.4-2.8H354.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    points: "375.6,4.1  401.4,4.1 383.7,70.1 357.9,70.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062187645371864343170000013449877253849921722_)",
      fill: "#0071CE"
    },
    d: "M436.7,35.7 c3.1,0,6.5,1.1,6.5,4.9c0,1.9-0.4,3.4-0.8,5c-1.6,5.7-4.7,9.5-11.1,9.5c-3.7,0-6.7-1.2-6.7-5.4c0-1.3,0.4-2.8,0.8-4.2 C427.4,39.1,429.6,35.7,436.7,35.7 M479.6,4.1h-26.1l-6.4,24.5H447c-0.4-10.5-6.7-13.8-17.8-13.8c-12.3,0-21.5,5.6-25.6,17.6 c-2.6,7.5-5.4,15.9-5.4,24.6c0,11,8,14.9,17.9,14.9c9.7,0,17.8-3.9,22.4-12.6h0.2l-3.3,10.8h25.9L479.6,4.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelfieldColor);
export default __webpack_public_path__ + "static/media/Delfield_Color.18ddd59e1c1f7af97e77d3f12cc8d3d6.svg";
export { ForwardRef as ReactComponent };